import HcrFormFields from './HcrFormFields.component';

export default HcrFormFields;